import type { AdminAgentApproval } from "../models/admin-agent.models";
import { formatAdminAgentReviewSql, readAdminAgentSqlReviewQueries } from "../utils/admin-agent.utils";

const AdminAgentSqlReview = ({ approval }: { approval: AdminAgentApproval }) => {
  const context = approval.sqlContext;
  const queries = readAdminAgentSqlReviewQueries(approval.arguments.queries);

  if (!context) return null;

  return (
    <div className="my-2 max-h-[45vh] space-y-3 overflow-auto" data-test="admin-agent-sql-review">
      <p data-test="admin-agent-sql-target">
        {context.environment.toUpperCase()} · {context.database}/{context.schema} · {context.maxRows} rows/query ·{" "}
        {context.queryTimeoutSeconds}s/query
      </p>
      {context.executedSql.map((sql, index) => (
        <div key={queries[index]?.id ?? index} className="space-y-1">
          <p className="font-semibold">
            {queries[index]?.id ?? `Q${index + 1}`} · {queries[index]?.purpose}
          </p>
          <pre
            data-test="admin-agent-sql-final-query"
            className="overflow-x-auto whitespace-pre rounded bg-white/80 p-3 font-mono text-xs dark:bg-black/20"
          >
            {formatAdminAgentReviewSql(sql, queries[index]?.binds ?? [])}
          </pre>
        </div>
      ))}
      <details data-test="admin-agent-sql-details">
        <summary className="cursor-pointer">Connection details and warnings</summary>
        <dl className="mt-2 grid grid-cols-[auto_1fr] gap-x-2 gap-y-1 break-all rounded bg-white/60 p-2 dark:bg-black/20">
          <dt>Relay environment</dt>
          <dd>{context.environment}</dd>
          <dt>Snowflake account</dt>
          <dd>{context.account}</dd>
          <dt>Database / schema</dt>
          <dd>
            {context.database} / {context.schema}
          </dd>
          <dt>User / application role</dt>
          <dd>
            {context.user} / {context.role}
          </dd>
          <dt>Warehouse</dt>
          <dd>{context.warehouse}</dd>
          <dt>Limits</dt>
          <dd>
            {context.maxRows} rows/query · {context.queryTimeoutSeconds}s/query · {context.batchTimeoutSeconds}s/batch ·{" "}
            {context.maxResultBytes} bytes/result
          </dd>
        </dl>
        <ul className="mt-2 list-disc space-y-2 pl-4" aria-label="SQL execution warnings">
          {approval.warnings?.map((warning) => <li key={warning}>{warning}</li>)}
        </ul>
      </details>
    </div>
  );
};

export default AdminAgentSqlReview;
